module.exports = {
  "ids": {
    "input-fields": {
      "closed": {
        "font-weight": {
          "type": "font-weight",
          "nob": [
            "system",
            "component",
            "element",
            "property"
          ],
          "value": 126,
          "filePath": "./src/tokens/closed.json",
          "isSource": true,
          "original": {
            "type": "font-weight",
            "nob": [
              "system",
              "component",
              "element",
              "property"
            ],
            "value": "{ids.font.weight.126.value}"
          },
          "name": "IDS_INPUT_FIELDS_CLOSED_FONT_WEIGHT",
          "attributes": {
            "system": "ids",
            "component": "input-fields",
            "element": "closed",
            "property": "font-weight"
          },
          "path": [
            "ids",
            "input-fields",
            "closed",
            "font-weight"
          ]
        }
      },
      "focus": {
        "border-width": {
          "type": "size",
          "nob": [
            "system",
            "component",
            "variant",
            "property"
          ],
          "value": "0.0625rem",
          "filePath": "./src/tokens/focus.json",
          "isSource": true,
          "original": {
            "type": "size",
            "nob": [
              "system",
              "component",
              "variant",
              "property"
            ],
            "value": "0.0625rem"
          },
          "name": "IDS_INPUT_FIELDS_FOCUS_BORDER_WIDTH",
          "attributes": {
            "system": "ids",
            "component": "input-fields",
            "variant": "focus",
            "property": "border-width"
          },
          "path": [
            "ids",
            "input-fields",
            "focus",
            "border-width"
          ]
        },
        "border-color": {
          "type": "color",
          "nob": [
            "system",
            "component",
            "variant",
            "property"
          ],
          "value": "rgb(0, 84, 240)",
          "filePath": "./src/tokens/focus.json",
          "isSource": true,
          "original": {
            "type": "color",
            "nob": [
              "system",
              "component",
              "variant",
              "property"
            ],
            "value": "{ids.color.states.focus}"
          },
          "name": "IDS_INPUT_FIELDS_FOCUS_BORDER_COLOR",
          "attributes": {
            "system": "ids",
            "component": "input-fields",
            "variant": "focus",
            "property": "border-color"
          },
          "path": [
            "ids",
            "input-fields",
            "focus",
            "border-color"
          ]
        },
        "border-style": {
          "type": "style",
          "nob": [
            "system",
            "component",
            "variant",
            "property"
          ],
          "value": "solid",
          "filePath": "./src/tokens/focus.json",
          "isSource": true,
          "original": {
            "type": "style",
            "nob": [
              "system",
              "component",
              "variant",
              "property"
            ],
            "value": "solid"
          },
          "name": "IDS_INPUT_FIELDS_FOCUS_BORDER_STYLE",
          "attributes": {
            "system": "ids",
            "component": "input-fields",
            "variant": "focus",
            "property": "border-style"
          },
          "path": [
            "ids",
            "input-fields",
            "focus",
            "border-style"
          ]
        }
      },
      "hover": {
        "outline-width": {
          "type": "size",
          "nob": [
            "system",
            "component",
            "variant",
            "property"
          ],
          "value": "0.0625rem",
          "filePath": "./src/tokens/hover.json",
          "isSource": true,
          "original": {
            "type": "size",
            "nob": [
              "system",
              "component",
              "variant",
              "property"
            ],
            "value": "0.0625rem"
          },
          "name": "IDS_INPUT_FIELDS_HOVER_OUTLINE_WIDTH",
          "attributes": {
            "system": "ids",
            "component": "input-fields",
            "variant": "hover",
            "property": "outline-width"
          },
          "path": [
            "ids",
            "input-fields",
            "hover",
            "outline-width"
          ]
        },
        "outline-color": {
          "type": "color",
          "nob": [
            "system",
            "component",
            "variant",
            "property"
          ],
          "value": "rgb(51, 30, 17)",
          "filePath": "./src/tokens/hover.json",
          "isSource": true,
          "original": {
            "type": "color",
            "nob": [
              "system",
              "component",
              "variant",
              "property"
            ],
            "value": "rgb(51, 30, 17)"
          },
          "name": "IDS_INPUT_FIELDS_HOVER_OUTLINE_COLOR",
          "attributes": {
            "system": "ids",
            "component": "input-fields",
            "variant": "hover",
            "property": "outline-color"
          },
          "path": [
            "ids",
            "input-fields",
            "hover",
            "outline-color"
          ]
        },
        "outline-style": {
          "type": "style",
          "nob": [
            "system",
            "component",
            "variant",
            "property"
          ],
          "value": "solid",
          "filePath": "./src/tokens/hover.json",
          "isSource": true,
          "original": {
            "type": "style",
            "nob": [
              "system",
              "component",
              "variant",
              "property"
            ],
            "value": "solid"
          },
          "name": "IDS_INPUT_FIELDS_HOVER_OUTLINE_STYLE",
          "attributes": {
            "system": "ids",
            "component": "input-fields",
            "variant": "hover",
            "property": "outline-style"
          },
          "path": [
            "ids",
            "input-fields",
            "hover",
            "outline-style"
          ]
        }
      },
      "error": {
        "margin-top": {
          "type": "size",
          "nob": [
            "system",
            "component",
            "element",
            "property"
          ],
          "value": "0.5rem",
          "filePath": "./src/tokens/input-error.json",
          "isSource": true,
          "original": {
            "type": "size",
            "nob": [
              "system",
              "component",
              "element",
              "property"
            ],
            "value": "{ids.size.spacing.8.value}"
          },
          "name": "IDS_INPUT_FIELDS_ERROR_MARGIN_TOP",
          "attributes": {
            "system": "ids",
            "component": "input-fields",
            "element": "error",
            "property": "margin-top"
          },
          "path": [
            "ids",
            "input-fields",
            "error",
            "margin-top"
          ]
        },
        "color": {
          "nob": [
            "system",
            "component",
            "element",
            "property"
          ],
          "value": "rgb(187, 50, 12)",
          "filePath": "./src/tokens/input-error.json",
          "isSource": true,
          "original": {
            "nob": [
              "system",
              "component",
              "element",
              "property"
            ],
            "value": "{ids.color.status.error.value}"
          },
          "name": "IDS_INPUT_FIELDS_ERROR_COLOR",
          "attributes": {
            "system": "ids",
            "component": "input-fields",
            "element": "error",
            "property": "color"
          },
          "path": [
            "ids",
            "input-fields",
            "error",
            "color"
          ]
        },
        "font-size": {
          "nob": [
            "system",
            "component",
            "element",
            "property"
          ],
          "value": "1.125rem",
          "filePath": "./src/tokens/input-error.json",
          "isSource": true,
          "original": {
            "nob": [
              "system",
              "component",
              "element",
              "property"
            ],
            "value": "{ids.font.size.18.value}"
          },
          "name": "IDS_INPUT_FIELDS_ERROR_FONT_SIZE",
          "attributes": {
            "system": "ids",
            "component": "input-fields",
            "element": "error",
            "property": "font-size"
          },
          "path": [
            "ids",
            "input-fields",
            "error",
            "font-size"
          ]
        },
        "line-height": {
          "nob": [
            "system",
            "component",
            "element",
            "property"
          ],
          "value": "1.75rem",
          "filePath": "./src/tokens/input-error.json",
          "isSource": true,
          "original": {
            "nob": [
              "system",
              "component",
              "element",
              "property"
            ],
            "value": "{ids.size.line-height.28.value}"
          },
          "name": "IDS_INPUT_FIELDS_ERROR_LINE_HEIGHT",
          "attributes": {
            "system": "ids",
            "component": "input-fields",
            "element": "error",
            "property": "line-height"
          },
          "path": [
            "ids",
            "input-fields",
            "error",
            "line-height"
          ]
        },
        "font-weight": {
          "type": "font-weight",
          "nob": [
            "system",
            "component",
            "element",
            "property"
          ],
          "value": 82,
          "filePath": "./src/tokens/input-error.json",
          "isSource": true,
          "original": {
            "type": "font-weight",
            "nob": [
              "system",
              "component",
              "element",
              "property"
            ],
            "value": "{ids.font.weight.82.value}"
          },
          "name": "IDS_INPUT_FIELDS_ERROR_FONT_WEIGHT",
          "attributes": {
            "system": "ids",
            "component": "input-fields",
            "element": "error",
            "property": "font-weight"
          },
          "path": [
            "ids",
            "input-fields",
            "error",
            "font-weight"
          ]
        }
      },
      "border-radius": {
        "type": "size",
        "nob": [
          "system",
          "component",
          "property"
        ],
        "value": "0.375rem",
        "filePath": "./src/tokens/input-fields.json",
        "isSource": true,
        "original": {
          "type": "size",
          "nob": [
            "system",
            "component",
            "property"
          ],
          "value": "0.375rem"
        },
        "name": "IDS_INPUT_FIELDS_BORDER_RADIUS",
        "attributes": {
          "system": "ids",
          "component": "input-fields",
          "property": "border-radius"
        },
        "path": [
          "ids",
          "input-fields",
          "border-radius"
        ]
      },
      "color": {
        "nob": [
          "system",
          "component",
          "property"
        ],
        "modify": [
          {
            "type": "alpha",
            "amount": "0.9"
          }
        ],
        "value": "rgba(51,30,17,0.9)",
        "filePath": "./src/tokens/input-fields.json",
        "isSource": true,
        "original": {
          "nob": [
            "system",
            "component",
            "property"
          ],
          "modify": [
            {
              "type": "alpha",
              "amount": "0.9"
            }
          ],
          "value": "{ids.color.text.primary.on-light.value}"
        },
        "name": "IDS_INPUT_FIELDS_COLOR",
        "attributes": {
          "system": "ids",
          "component": "input-fields",
          "property": "color"
        },
        "path": [
          "ids",
          "input-fields",
          "color"
        ]
      },
      "background-color": {
        "type": "color",
        "nob": [
          "system",
          "component",
          "property"
        ],
        "value": "rgb(255, 255, 255)",
        "filePath": "./src/tokens/input-fields.json",
        "isSource": true,
        "original": {
          "type": "color",
          "nob": [
            "system",
            "component",
            "property"
          ],
          "value": "{ids.color.white.value}"
        },
        "name": "IDS_INPUT_FIELDS_BACKGROUND_COLOR",
        "attributes": {
          "system": "ids",
          "component": "input-fields",
          "property": "background-color"
        },
        "path": [
          "ids",
          "input-fields",
          "background-color"
        ]
      },
      "border": {
        "nob": [
          "system",
          "component",
          "property"
        ],
        "value": "0.0625rem solid rgb(110, 98, 94)",
        "filePath": "./src/tokens/input-fields.json",
        "isSource": true,
        "original": {
          "nob": [
            "system",
            "component",
            "property"
          ],
          "value": "0.0625rem solid {ids.color.brown.100.value}"
        },
        "name": "IDS_INPUT_FIELDS_BORDER",
        "attributes": {
          "system": "ids",
          "component": "input-fields",
          "property": "border"
        },
        "path": [
          "ids",
          "input-fields",
          "border"
        ]
      },
      "font-size": {
        "type": "font-size",
        "nob": [
          "system",
          "component",
          "property"
        ],
        "value": "1.125rem",
        "filePath": "./src/tokens/input-fields.json",
        "isSource": true,
        "original": {
          "type": "font-size",
          "nob": [
            "system",
            "component",
            "property"
          ],
          "value": "{ids.font.size.18.value}"
        },
        "name": "IDS_INPUT_FIELDS_FONT_SIZE",
        "attributes": {
          "system": "ids",
          "component": "input-fields",
          "property": "font-size"
        },
        "path": [
          "ids",
          "input-fields",
          "font-size"
        ]
      },
      "height": {
        "type": "size",
        "nob": [
          "system",
          "component",
          "property"
        ],
        "value": "3rem",
        "filePath": "./src/tokens/input-fields.json",
        "isSource": true,
        "original": {
          "type": "size",
          "nob": [
            "system",
            "component",
            "property"
          ],
          "value": "{ids.size.48.value}"
        },
        "name": "IDS_INPUT_FIELDS_HEIGHT",
        "attributes": {
          "system": "ids",
          "component": "input-fields",
          "property": "height"
        },
        "path": [
          "ids",
          "input-fields",
          "height"
        ]
      },
      "width": {
        "media-query": {
          "base": {
            "nob": [
              "system",
              "component",
              "property",
              "category",
              "scale"
            ],
            "value": "100%",
            "filePath": "./src/tokens/input-fields.json",
            "isSource": true,
            "original": {
              "nob": [
                "system",
                "component",
                "property",
                "category",
                "scale"
              ],
              "value": "100%"
            },
            "name": "IDS_INPUT_FIELDS_WIDTH_MEDIA_QUERY_BASE",
            "attributes": {
              "system": "ids",
              "component": "input-fields",
              "property": "width",
              "category": "media-query",
              "scale": "base"
            },
            "path": [
              "ids",
              "input-fields",
              "width",
              "media-query",
              "base"
            ]
          },
          "md": {
            "nob": [
              "system",
              "component",
              "property",
              "category",
              "scale"
            ],
            "value": "296px",
            "filePath": "./src/tokens/input-fields.json",
            "isSource": true,
            "original": {
              "nob": [
                "system",
                "component",
                "property",
                "category",
                "scale"
              ],
              "value": "296px"
            },
            "name": "IDS_INPUT_FIELDS_WIDTH_MEDIA_QUERY_MD",
            "attributes": {
              "system": "ids",
              "component": "input-fields",
              "property": "width",
              "category": "media-query",
              "scale": "md"
            },
            "path": [
              "ids",
              "input-fields",
              "width",
              "media-query",
              "md"
            ]
          }
        }
      },
      "spacing": {
        "inset": {
          "horizontal": {
            "type": "size",
            "nob": [
              "system",
              "component",
              "concept",
              "variant",
              "mode"
            ],
            "value": "1rem",
            "filePath": "./src/tokens/input-fields.json",
            "isSource": true,
            "original": {
              "type": "size",
              "nob": [
                "system",
                "component",
                "concept",
                "variant",
                "mode"
              ],
              "value": "{ids.size.spacing.smaller.value}"
            },
            "name": "IDS_INPUT_FIELDS_SPACING_INSET_HORIZONTAL",
            "attributes": {
              "system": "ids",
              "component": "input-fields",
              "concept": "spacing",
              "variant": "inset",
              "mode": "horizontal"
            },
            "path": [
              "ids",
              "input-fields",
              "spacing",
              "inset",
              "horizontal"
            ]
          },
          "vertical": {
            "type": "size",
            "nob": [
              "system",
              "component",
              "concept",
              "variant",
              "mode"
            ],
            "value": "0",
            "filePath": "./src/tokens/input-fields.json",
            "isSource": true,
            "original": {
              "type": "size",
              "nob": [
                "system",
                "component",
                "concept",
                "variant",
                "mode"
              ],
              "value": "0"
            },
            "name": "IDS_INPUT_FIELDS_SPACING_INSET_VERTICAL",
            "attributes": {
              "system": "ids",
              "component": "input-fields",
              "concept": "spacing",
              "variant": "inset",
              "mode": "vertical"
            },
            "path": [
              "ids",
              "input-fields",
              "spacing",
              "inset",
              "vertical"
            ]
          }
        }
      },
      "transition": {
        "nob": [
          "system",
          "component",
          "property"
        ],
        "value": "all 0.1s cubic-bezier(0.4, 0.0, 0.2, 1)",
        "filePath": "./src/tokens/input-fields.json",
        "isSource": true,
        "original": {
          "nob": [
            "system",
            "component",
            "property"
          ],
          "value": "all 0.1s cubic-bezier(0.4, 0.0, 0.2, 1)"
        },
        "name": "IDS_INPUT_FIELDS_TRANSITION",
        "attributes": {
          "system": "ids",
          "component": "input-fields",
          "property": "transition"
        },
        "path": [
          "ids",
          "input-fields",
          "transition"
        ]
      },
      "help": {
        "margin-top": {
          "type": "size",
          "nob": [
            "system",
            "component",
            "element",
            "property"
          ],
          "value": "0.5rem",
          "filePath": "./src/tokens/input-help.json",
          "isSource": true,
          "original": {
            "type": "size",
            "nob": [
              "system",
              "component",
              "element",
              "property"
            ],
            "value": "{ids.size.spacing.8.value}"
          },
          "name": "IDS_INPUT_FIELDS_HELP_MARGIN_TOP",
          "attributes": {
            "system": "ids",
            "component": "input-fields",
            "element": "help",
            "property": "margin-top"
          },
          "path": [
            "ids",
            "input-fields",
            "help",
            "margin-top"
          ]
        },
        "color": {
          "nob": [
            "system",
            "component",
            "element",
            "property"
          ],
          "value": "rgb(110, 98, 94)",
          "filePath": "./src/tokens/input-help.json",
          "isSource": true,
          "original": {
            "nob": [
              "system",
              "component",
              "element",
              "property"
            ],
            "value": "{ids.color.brown.100.value}"
          },
          "name": "IDS_INPUT_FIELDS_HELP_COLOR",
          "attributes": {
            "system": "ids",
            "component": "input-fields",
            "element": "help",
            "property": "color"
          },
          "path": [
            "ids",
            "input-fields",
            "help",
            "color"
          ]
        },
        "font-size": {
          "type": "font-size",
          "nob": [
            "system",
            "component",
            "element",
            "property"
          ],
          "value": "1.125rem",
          "filePath": "./src/tokens/input-help.json",
          "isSource": true,
          "original": {
            "type": "font-size",
            "nob": [
              "system",
              "component",
              "element",
              "property"
            ],
            "value": "{ids.font.size.18.value}"
          },
          "name": "IDS_INPUT_FIELDS_HELP_FONT_SIZE",
          "attributes": {
            "system": "ids",
            "component": "input-fields",
            "element": "help",
            "property": "font-size"
          },
          "path": [
            "ids",
            "input-fields",
            "help",
            "font-size"
          ]
        },
        "line-height": {
          "nob": [
            "system",
            "component",
            "element",
            "property"
          ],
          "value": "1.75rem",
          "filePath": "./src/tokens/input-help.json",
          "isSource": true,
          "original": {
            "nob": [
              "system",
              "component",
              "element",
              "property"
            ],
            "value": "{ids.size.line-height.28.value}"
          },
          "name": "IDS_INPUT_FIELDS_HELP_LINE_HEIGHT",
          "attributes": {
            "system": "ids",
            "component": "input-fields",
            "element": "help",
            "property": "line-height"
          },
          "path": [
            "ids",
            "input-fields",
            "help",
            "line-height"
          ]
        },
        "font-weight": {
          "type": "font-weight",
          "nob": [
            "system",
            "component",
            "element",
            "property"
          ],
          "value": 82,
          "filePath": "./src/tokens/input-help.json",
          "isSource": true,
          "original": {
            "type": "font-weight",
            "nob": [
              "system",
              "component",
              "element",
              "property"
            ],
            "value": "{ids.font.weight.82.value}"
          },
          "name": "IDS_INPUT_FIELDS_HELP_FONT_WEIGHT",
          "attributes": {
            "system": "ids",
            "component": "input-fields",
            "element": "help",
            "property": "font-weight"
          },
          "path": [
            "ids",
            "input-fields",
            "help",
            "font-weight"
          ]
        }
      },
      "wrapper": {
        "spacing": {
          "stacking": {
            "downwards": {
              "type": "size",
              "nob": [
                "system",
                "component",
                "element",
                "concept",
                "variant",
                "mode"
              ],
              "value": "2rem",
              "filePath": "./src/tokens/input-wrapper.json",
              "isSource": true,
              "original": {
                "type": "size",
                "nob": [
                  "system",
                  "component",
                  "element",
                  "concept",
                  "variant",
                  "mode"
                ],
                "value": "{ids.size.spacing.default.value}"
              },
              "name": "IDS_INPUT_FIELDS_WRAPPER_SPACING_STACKING_DOWNWARDS",
              "attributes": {
                "system": "ids",
                "component": "input-fields",
                "element": "wrapper",
                "concept": "spacing",
                "variant": "stacking",
                "mode": "downwards"
              },
              "path": [
                "ids",
                "input-fields",
                "wrapper",
                "spacing",
                "stacking",
                "downwards"
              ]
            },
            "upwards": {
              "type": "size",
              "nob": [
                "system",
                "component",
                "element",
                "concept",
                "variant",
                "mode"
              ],
              "value": "1rem",
              "filePath": "./src/tokens/input-wrapper.json",
              "isSource": true,
              "original": {
                "type": "size",
                "nob": [
                  "system",
                  "component",
                  "element",
                  "concept",
                  "variant",
                  "mode"
                ],
                "value": "{ids.size.spacing.smaller.value}"
              },
              "name": "IDS_INPUT_FIELDS_WRAPPER_SPACING_STACKING_UPWARDS",
              "attributes": {
                "system": "ids",
                "component": "input-fields",
                "element": "wrapper",
                "concept": "spacing",
                "variant": "stacking",
                "mode": "upwards"
              },
              "path": [
                "ids",
                "input-fields",
                "wrapper",
                "spacing",
                "stacking",
                "upwards"
              ]
            }
          }
        }
      },
      "placeholder": {
        "color": {
          "nob": [
            "system",
            "component",
            "element",
            "property"
          ],
          "modify": [
            {
              "type": "alpha",
              "amount": "0.6"
            }
          ],
          "value": "rgba(110,98,94,0.6)",
          "filePath": "./src/tokens/placeholder.json",
          "isSource": true,
          "original": {
            "nob": [
              "system",
              "component",
              "element",
              "property"
            ],
            "modify": [
              {
                "type": "alpha",
                "amount": "0.6"
              }
            ],
            "value": "{ids.color.brown.100.value}"
          },
          "name": "IDS_INPUT_FIELDS_PLACEHOLDER_COLOR",
          "attributes": {
            "system": "ids",
            "component": "input-fields",
            "element": "placeholder",
            "property": "color"
          },
          "path": [
            "ids",
            "input-fields",
            "placeholder",
            "color"
          ]
        }
      },
      "reset": {
        "background-image": {
          "nob": [
            "system",
            "component",
            "element",
            "property"
          ],
          "value": "url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 32 32%27%3E%3Ctitle%3Ee remove%3C/title%3E%3Cg class=%27nc-icon-wrapper%27 stroke-linecap=%27square%27 stroke-linejoin=%27miter%27 stroke-width=%275%27 fill=%27%23faf9f7%27 stroke=%27%23faf9f7%27%3E%3Cline fill=%27none%27 stroke=%27%23faf9f7%27 stroke-miterlimit=%2710%27 x1=%2727%27 y1=%275%27 x2=%275%27 y2=%2727%27/%3E%3Cline fill=%27none%27 stroke=%27%23faf9f7%27 stroke-miterlimit=%2710%27 x1=%2727%27 y1=%2727%27 x2=%275%27 y2=%275%27/%3E%3C/g%3E%3C/svg%3E\")",
          "filePath": "./src/tokens/reset.json",
          "isSource": true,
          "original": {
            "nob": [
              "system",
              "component",
              "element",
              "property"
            ],
            "value": "url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 32 32%27%3E%3Ctitle%3Ee remove%3C/title%3E%3Cg class=%27nc-icon-wrapper%27 stroke-linecap=%27square%27 stroke-linejoin=%27miter%27 stroke-width=%275%27 fill=%27%23faf9f7%27 stroke=%27%23faf9f7%27%3E%3Cline fill=%27none%27 stroke=%27%23faf9f7%27 stroke-miterlimit=%2710%27 x1=%2727%27 y1=%275%27 x2=%275%27 y2=%2727%27/%3E%3Cline fill=%27none%27 stroke=%27%23faf9f7%27 stroke-miterlimit=%2710%27 x1=%2727%27 y1=%2727%27 x2=%275%27 y2=%275%27/%3E%3C/g%3E%3C/svg%3E\")"
          },
          "name": "IDS_INPUT_FIELDS_RESET_BACKGROUND_IMAGE",
          "attributes": {
            "system": "ids",
            "component": "input-fields",
            "element": "reset",
            "property": "background-image"
          },
          "path": [
            "ids",
            "input-fields",
            "reset",
            "background-image"
          ]
        },
        "background-color": {
          "nob": [
            "system",
            "component",
            "element",
            "property"
          ],
          "value": "rgb(110, 98, 94)",
          "filePath": "./src/tokens/reset.json",
          "isSource": true,
          "original": {
            "nob": [
              "system",
              "component",
              "element",
              "property"
            ],
            "value": "{ids.color.brown.100.value}"
          },
          "name": "IDS_INPUT_FIELDS_RESET_BACKGROUND_COLOR",
          "attributes": {
            "system": "ids",
            "component": "input-fields",
            "element": "reset",
            "property": "background-color"
          },
          "path": [
            "ids",
            "input-fields",
            "reset",
            "background-color"
          ]
        }
      },
      "disabled": {
        "color": {
          "nob": [
            "system",
            "component",
            "element",
            "property"
          ],
          "value": "rgba(110,98,94,0.3)",
          "filePath": "./src/tokens/states.json",
          "isSource": true,
          "original": {
            "nob": [
              "system",
              "component",
              "element",
              "property"
            ],
            "value": "{ids.color.states.disabled.value}"
          },
          "name": "IDS_INPUT_FIELDS_DISABLED_COLOR",
          "attributes": {
            "system": "ids",
            "component": "input-fields",
            "element": "disabled",
            "property": "color"
          },
          "path": [
            "ids",
            "input-fields",
            "disabled",
            "color"
          ]
        },
        "background-color": {
          "nob": [
            "system",
            "component",
            "element",
            "property"
          ],
          "modify": [
            {
              "type": "alpha",
              "amount": "0.7"
            }
          ],
          "value": "rgba(250,249,247,0.7)",
          "filePath": "./src/tokens/states.json",
          "isSource": true,
          "original": {
            "nob": [
              "system",
              "component",
              "element",
              "property"
            ],
            "modify": [
              {
                "type": "alpha",
                "amount": "0.7"
              }
            ],
            "value": "{ids.color.background.100.value}"
          },
          "name": "IDS_INPUT_FIELDS_DISABLED_BACKGROUND_COLOR",
          "attributes": {
            "system": "ids",
            "component": "input-fields",
            "element": "disabled",
            "property": "background-color"
          },
          "path": [
            "ids",
            "input-fields",
            "disabled",
            "background-color"
          ]
        },
        "border-color": {
          "nob": [
            "system",
            "component",
            "element",
            "property"
          ],
          "value": "rgba(110,98,94,0.3)",
          "filePath": "./src/tokens/states.json",
          "isSource": true,
          "original": {
            "nob": [
              "system",
              "component",
              "element",
              "property"
            ],
            "value": "{ids.color.states.disabled.value}"
          },
          "name": "IDS_INPUT_FIELDS_DISABLED_BORDER_COLOR",
          "attributes": {
            "system": "ids",
            "component": "input-fields",
            "element": "disabled",
            "property": "border-color"
          },
          "path": [
            "ids",
            "input-fields",
            "disabled",
            "border-color"
          ]
        }
      },
      "invalid": {
        "border-color": {
          "nob": [
            "system",
            "component",
            "element",
            "property"
          ],
          "value": "rgb(187, 50, 12)",
          "filePath": "./src/tokens/states.json",
          "isSource": true,
          "original": {
            "nob": [
              "system",
              "component",
              "element",
              "property"
            ],
            "value": "{ids.color.status.error.value}"
          },
          "name": "IDS_INPUT_FIELDS_INVALID_BORDER_COLOR",
          "attributes": {
            "system": "ids",
            "component": "input-fields",
            "element": "invalid",
            "property": "border-color"
          },
          "path": [
            "ids",
            "input-fields",
            "invalid",
            "border-color"
          ]
        },
        "border-width": {
          "type": "size",
          "nob": [
            "system",
            "component",
            "element",
            "property"
          ],
          "value": "0.125rem",
          "filePath": "./src/tokens/states.json",
          "isSource": true,
          "original": {
            "type": "size",
            "nob": [
              "system",
              "component",
              "element",
              "property"
            ],
            "value": "0.125rem"
          },
          "name": "IDS_INPUT_FIELDS_INVALID_BORDER_WIDTH",
          "attributes": {
            "system": "ids",
            "component": "input-fields",
            "element": "invalid",
            "property": "border-width"
          },
          "path": [
            "ids",
            "input-fields",
            "invalid",
            "border-width"
          ]
        }
      },
      "date": {
        "background-image": {
          "nob": [
            "system",
            "component",
            "element",
            "property"
          ],
          "value": "url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 32 32%27%3E%3Ctitle%3Ecalendar%3C/title%3E%3Cg class=%27nc-icon-wrapper%27 stroke-linecap=%27square%27 stroke-linejoin=%27miter%27 stroke-width=%271.5%27 fill=%27%23331e11%27 stroke=%27%23331e11%27%3E%3Cline data-color=%27color-2%27 x1=%279%27 y1=%271%27 x2=%279%27 y2=%275%27 fill=%27none%27 stroke-miterlimit=%2710%27/%3E%3Cline data-color=%27color-2%27 x1=%2723%27 y1=%271%27 x2=%2723%27 y2=%275%27 fill=%27none%27 stroke-miterlimit=%2710%27/%3E%3Cline data-cap=%27butt%27 data-color=%27color-2%27 x1=%2731%27 y1=%2711%27 x2=%271%27 y2=%2711%27 fill=%27none%27 stroke-miterlimit=%2710%27 stroke-linecap=%27butt%27/%3E%3Crect x=%271%27 y=%275%27 width=%2730%27 height=%2724%27 fill=%27none%27 stroke=%27%23331e11%27 stroke-miterlimit=%2710%27/%3E%3C/g%3E%3C/svg%3E\")",
          "filePath": "./src/tokens/type-date.json",
          "isSource": true,
          "original": {
            "nob": [
              "system",
              "component",
              "element",
              "property"
            ],
            "value": "url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 32 32%27%3E%3Ctitle%3Ecalendar%3C/title%3E%3Cg class=%27nc-icon-wrapper%27 stroke-linecap=%27square%27 stroke-linejoin=%27miter%27 stroke-width=%271.5%27 fill=%27%23331e11%27 stroke=%27%23331e11%27%3E%3Cline data-color=%27color-2%27 x1=%279%27 y1=%271%27 x2=%279%27 y2=%275%27 fill=%27none%27 stroke-miterlimit=%2710%27/%3E%3Cline data-color=%27color-2%27 x1=%2723%27 y1=%271%27 x2=%2723%27 y2=%275%27 fill=%27none%27 stroke-miterlimit=%2710%27/%3E%3Cline data-cap=%27butt%27 data-color=%27color-2%27 x1=%2731%27 y1=%2711%27 x2=%271%27 y2=%2711%27 fill=%27none%27 stroke-miterlimit=%2710%27 stroke-linecap=%27butt%27/%3E%3Crect x=%271%27 y=%275%27 width=%2730%27 height=%2724%27 fill=%27none%27 stroke=%27%23331e11%27 stroke-miterlimit=%2710%27/%3E%3C/g%3E%3C/svg%3E\")"
          },
          "name": "IDS_INPUT_FIELDS_DATE_BACKGROUND_IMAGE",
          "attributes": {
            "system": "ids",
            "component": "input-fields",
            "element": "date",
            "property": "background-image"
          },
          "path": [
            "ids",
            "input-fields",
            "date",
            "background-image"
          ]
        },
        "background-size": {
          "nob": [
            "system",
            "component",
            "element",
            "property"
          ],
          "value": "1.5rem 1.5rem",
          "filePath": "./src/tokens/type-date.json",
          "isSource": true,
          "original": {
            "nob": [
              "system",
              "component",
              "element",
              "property"
            ],
            "value": "1.5rem 1.5rem"
          },
          "name": "IDS_INPUT_FIELDS_DATE_BACKGROUND_SIZE",
          "attributes": {
            "system": "ids",
            "component": "input-fields",
            "element": "date",
            "property": "background-size"
          },
          "path": [
            "ids",
            "input-fields",
            "date",
            "background-size"
          ]
        },
        "background-position": {
          "nob": [
            "system",
            "component",
            "element",
            "property"
          ],
          "value": "right 0.75rem center",
          "filePath": "./src/tokens/type-date.json",
          "isSource": true,
          "original": {
            "nob": [
              "system",
              "component",
              "element",
              "property"
            ],
            "value": "right {ids.size.12.value} center"
          },
          "name": "IDS_INPUT_FIELDS_DATE_BACKGROUND_POSITION",
          "attributes": {
            "system": "ids",
            "component": "input-fields",
            "element": "date",
            "property": "background-position"
          },
          "path": [
            "ids",
            "input-fields",
            "date",
            "background-position"
          ]
        },
        "padding-right": {
          "type": "size",
          "nob": [
            "system",
            "component",
            "element",
            "property"
          ],
          "value": "3rem",
          "filePath": "./src/tokens/type-date.json",
          "isSource": true,
          "original": {
            "type": "size",
            "nob": [
              "system",
              "component",
              "element",
              "property"
            ],
            "value": "{ids.size.spacing.48.value}"
          },
          "name": "IDS_INPUT_FIELDS_DATE_PADDING_RIGHT",
          "attributes": {
            "system": "ids",
            "component": "input-fields",
            "element": "date",
            "property": "padding-right"
          },
          "path": [
            "ids",
            "input-fields",
            "date",
            "padding-right"
          ]
        }
      },
      "with-icon": {
        "leading": {
          "background-position": {
            "nob": [
              "system",
              "component",
              "element",
              "variant",
              "property"
            ],
            "value": "left 0.75rem center",
            "filePath": "./src/tokens/with-icon.json",
            "isSource": true,
            "original": {
              "nob": [
                "system",
                "component",
                "element",
                "variant",
                "property"
              ],
              "value": "left {ids.size.12.value} center"
            },
            "name": "IDS_INPUT_FIELDS_WITH_ICON_LEADING_BACKGROUND_POSITION",
            "attributes": {
              "system": "ids",
              "component": "input-fields",
              "element": "with-icon",
              "variant": "leading",
              "property": "background-position"
            },
            "path": [
              "ids",
              "input-fields",
              "with-icon",
              "leading",
              "background-position"
            ]
          },
          "background-size": {
            "nob": [
              "system",
              "component",
              "element",
              "variant",
              "property"
            ],
            "value": "1.5rem 1.5rem",
            "filePath": "./src/tokens/with-icon.json",
            "isSource": true,
            "original": {
              "nob": [
                "system",
                "component",
                "element",
                "variant",
                "property"
              ],
              "value": "1.5rem 1.5rem"
            },
            "name": "IDS_INPUT_FIELDS_WITH_ICON_LEADING_BACKGROUND_SIZE",
            "attributes": {
              "system": "ids",
              "component": "input-fields",
              "element": "with-icon",
              "variant": "leading",
              "property": "background-size"
            },
            "path": [
              "ids",
              "input-fields",
              "with-icon",
              "leading",
              "background-size"
            ]
          },
          "padding-left": {
            "type": "size",
            "nob": [
              "system",
              "component",
              "element",
              "variant",
              "property"
            ],
            "value": "3rem",
            "filePath": "./src/tokens/with-icon.json",
            "isSource": true,
            "original": {
              "type": "size",
              "nob": [
                "system",
                "component",
                "element",
                "variant",
                "property"
              ],
              "value": "{ids.size.spacing.48.value}"
            },
            "name": "IDS_INPUT_FIELDS_WITH_ICON_LEADING_PADDING_LEFT",
            "attributes": {
              "system": "ids",
              "component": "input-fields",
              "element": "with-icon",
              "variant": "leading",
              "property": "padding-left"
            },
            "path": [
              "ids",
              "input-fields",
              "with-icon",
              "leading",
              "padding-left"
            ]
          }
        },
        "trailing": {
          "background-position": {
            "nob": [
              "system",
              "component",
              "element",
              "variant",
              "property"
            ],
            "value": "right 0.75rem center",
            "filePath": "./src/tokens/with-icon.json",
            "isSource": true,
            "original": {
              "nob": [
                "system",
                "component",
                "element",
                "variant",
                "property"
              ],
              "value": "right {ids.size.12.value} center"
            },
            "name": "IDS_INPUT_FIELDS_WITH_ICON_TRAILING_BACKGROUND_POSITION",
            "attributes": {
              "system": "ids",
              "component": "input-fields",
              "element": "with-icon",
              "variant": "trailing",
              "property": "background-position"
            },
            "path": [
              "ids",
              "input-fields",
              "with-icon",
              "trailing",
              "background-position"
            ]
          },
          "padding-left": {
            "type": "size",
            "nob": [
              "system",
              "component",
              "element",
              "variant",
              "property"
            ],
            "value": "1rem",
            "filePath": "./src/tokens/with-icon.json",
            "isSource": true,
            "original": {
              "type": "size",
              "nob": [
                "system",
                "component",
                "element",
                "variant",
                "property"
              ],
              "value": "{ids.size.spacing.16.value}"
            },
            "name": "IDS_INPUT_FIELDS_WITH_ICON_TRAILING_PADDING_LEFT",
            "attributes": {
              "system": "ids",
              "component": "input-fields",
              "element": "with-icon",
              "variant": "trailing",
              "property": "padding-left"
            },
            "path": [
              "ids",
              "input-fields",
              "with-icon",
              "trailing",
              "padding-left"
            ]
          },
          "padding-right": {
            "type": "size",
            "nob": [
              "system",
              "component",
              "element",
              "variant",
              "property"
            ],
            "value": "3rem",
            "filePath": "./src/tokens/with-icon.json",
            "isSource": true,
            "original": {
              "type": "size",
              "nob": [
                "system",
                "component",
                "element",
                "variant",
                "property"
              ],
              "value": "{ids.size.spacing.48.value}"
            },
            "name": "IDS_INPUT_FIELDS_WITH_ICON_TRAILING_PADDING_RIGHT",
            "attributes": {
              "system": "ids",
              "component": "input-fields",
              "element": "with-icon",
              "variant": "trailing",
              "property": "padding-right"
            },
            "path": [
              "ids",
              "input-fields",
              "with-icon",
              "trailing",
              "padding-right"
            ]
          }
        }
      }
    }
  }
};
